import { ProceedingParticipantType } from "../../api/ClientFileApi";

export interface ParticipantFormType {
  type: ProceedingParticipantType | null;
  name: string;
  street: string;
  houseNumber: string;
  country: string;
  zipCode: string;
  city: string;
  note: string | null;
}

export interface ClientSpecificParticipantFormType extends ParticipantFormType {
  createAsGlobal?: boolean;
}

/**
 * Mirrors the `ProceedingParticipant.*MaxLength` constants in the domain model. Address field
 * lengths are the shared defaults — see `AddressFieldMaxLength`.
 */
export const ParticipantMaxLength = {
  name: 255,
  note: 750,
};

/** Mirrors `ProceedingParticipant.ZipCodeMinLength`. */
export const ParticipantZipCodeMinLength = 4;
